module.exports = __webpack_public_path__ + "img/icon-auth-line.38991b93.svg";